const section = document.querySelector(".ns-customer-stories");
const container = document.querySelector(".ns-customer-stories__form");
const containerMobile = document.querySelector(".ns-customer-stories-mobile-filter");
const chipsContainer = document.querySelector(".ns-customer-stories__chips");
const chipsList = document.querySelector(".ns-customer-stories__chips-list");
const chipTemplate = document.querySelector(".ns-customer-stories__chip-template");
const buttonShowMore = document.querySelector('.ns-customer-stories__controls');
let idPage;
let industries = '';
let painpoints = '';
let isClear = false;

const onSubmitForm = () => {
    const fields = containerMobile.querySelectorAll(".ns-multiselect");
    const drawChips = () => {
        fields.forEach(($field) => {
            const $fieldInput = $field.querySelector(".ns-multiselect__input");
            const values = $fieldInput.value
                ? $fieldInput.value.split(",")
                : [];

            values.forEach((value) => {
                const clone = chipTemplate.content.cloneNode(true);
                const $text = clone.querySelector(".ns-chip__text");

                $text.textContent = value;

                const $clearButton = clone.querySelector(".ns-chip__clear");

                $clearButton.addEventListener("click", () => {
                    $field.dispatchEvent(
                        new CustomEvent("handle-remove-value", {
                            detail: {
                                value,
                            },
                        })
                    );
                });

                chipsList.appendChild(clone);
            });
        });
    };

    chipsList.innerHTML = "";
    drawChips();
    industries = '';
    painpoints = '';

    const totalValues = [...fields].reduce((accum, $el) => {
        const $elInput = $el.querySelector(".ns-multiselect__input");
        const value = $elInput.value ? $elInput.value.split(",") : [];

        if ($elInput.name === 'mobile-industry') {
            industries = encodeURIComponent($elInput.value);
        }

        if ($elInput.name === 'mobile-painpoint') {
            painpoints = encodeURIComponent($elInput.value);
        }

        return [...accum, ...value];
    }, []);

    if (totalValues && totalValues.length > 0) {
        chipsContainer.classList.add(
            "ns-customer-stories__chips--active"
        );
    } else {
        chipsContainer.classList.remove(
            "ns-customer-stories__chips--active"
        );
    }

    const request = new XMLHttpRequest();
    request.onload = () => {
        const response = JSON.parse(request.responseText);
        const template = document.querySelector('.ns-customer-stories__article-card-template');
        template.parentNode.querySelector('.ns-customer-stories__col').textContent = '';

        for (const story of response.stories) {
            const clone = template.content.cloneNode(true);
            clone.querySelector('.ns-article-card').href = story.alias;
            clone.querySelector('.ns-article-card').dataset.order = story.order;
            clone.querySelector('.ns-article-card__type-text').textContent = story.industry;
            clone.querySelector('.ns-article-card__title').textContent = story.title;
            clone.querySelector('.ns-article-card__description').textContent = story.description;

            if (story.media.type === 'image') {
                clone.querySelector('img').src = story.media.src;
                clone.querySelector('video').style.display = 'none';
                clone.querySelector('.ns-article-card__type-video-marker').style.display = 'none';
            } else if (story.media.type === 'video') {
                clone.querySelector('source').src = story.media.src;
                clone.querySelector('source').type = story.media.mime;
                clone.querySelector('img').style.display = 'none';
            }

            template.parentNode.querySelector('.ns-customer-stories__col').appendChild(clone);
        }

        if(response.stories.length < 1){
            document.querySelector(".ns-article-card__no-result--search").style.display = "block";
        }
        else{
            document.querySelector(".ns-article-card__no-result--search").style.display = "none";
        }

        if (buttonShowMore) {
            if (!response.hasNextPage) {
                buttonShowMore.style.display = 'none';
            } else {
                buttonShowMore.dataset.page = 2;
                buttonShowMore.style.display = 'flex';
            }
        }
    }
    request.open('GET', `/ajax/get-stories-filter/?idPage=${idPage}&industries=${industries}&painpoints=${painpoints}`);
    request.send();
}

const initDesktopFilter = () => {
    const $clearButton = document.querySelector(".ns-customer-stories__clear");

    const fields = container.querySelectorAll(".ns-multiselect");

    const drawChips = () => {
        fields.forEach(($field) => {
            const $fieldInput = $field.querySelector(".ns-multiselect__input");
            const values = $fieldInput.value
                ? $fieldInput.value.split(",")
                : [];

            values.forEach((value) => {
                const clone = chipTemplate.content.cloneNode(true);
                const $text = clone.querySelector(".ns-chip__text");

                $text.textContent = value;

                const $clearButton = clone.querySelector(".ns-chip__clear");

                $clearButton.addEventListener("click", () => {
                    $field.dispatchEvent(
                        new CustomEvent("handle-remove-value", {
                            detail: {
                                value,
                            },
                        })
                    );
                });

                chipsList.appendChild(clone);
            });
        });
    };

    fields.forEach(($field) => {
        $field.addEventListener("on-change", () => {
            chipsList.innerHTML = "";

            drawChips();
            industries = '';
            painpoints = '';
            const totalValues = [...fields].reduce((accum, $el) => {
                const $elInput = $el.querySelector(".ns-multiselect__input");
                const value = $elInput.value ? $elInput.value.split(",") : [];

                if ($elInput.name === 'industry') {
                    industries = encodeURIComponent($elInput.value);
                }

                if ($elInput.name === 'painpoint') {
                    painpoints = encodeURIComponent($elInput.value);
                }

                return [...accum, ...value];
            }, []);

            if (totalValues && totalValues.length > 0) {
                chipsContainer.classList.add(
                    "ns-customer-stories__chips--active"
                );
            } else {
                chipsContainer.classList.remove(
                    "ns-customer-stories__chips--active"
                );
            }

            if (isClear) {
                return;
            }

            const request = new XMLHttpRequest();
            request.onload = () => {
                const response = JSON.parse(request.responseText);
                const template = document.querySelector('.ns-customer-stories__article-card-template');
                template.parentNode.querySelector('.ns-customer-stories__col').textContent = '';

                for (const story of response.stories) {
                    const clone = template.content.cloneNode(true);
                    clone.querySelector('.ns-article-card').href = story.alias;
                    clone.querySelector('.ns-article-card').dataset.order = story.order;
                    clone.querySelector('.ns-article-card__type-text').textContent = story.industry;
                    clone.querySelector('.ns-article-card__title').textContent = story.title;
                    clone.querySelector('.ns-article-card__description').textContent = story.description;

                    if (story.media.type === 'image') {
                        clone.querySelector('img').src = story.media.src;
                        clone.querySelector('video').style.display = 'none';
                        clone.querySelector('.ns-article-card__type-video-marker').style.display = 'none';
                    } else if (story.media.type === 'video') {
                        clone.querySelector('source').src = story.media.src;
                        clone.querySelector('source').type = story.media.mime;
                        clone.querySelector('img').style.display = 'none';
                    }

                    template.parentNode.querySelector('.ns-customer-stories__col').appendChild(clone);
                }

                if(response.stories.length < 1){
                    document.querySelector(".ns-article-card__no-result--search").style.display = "block";
                }
                else{
                    document.querySelector(".ns-article-card__no-result--search").style.display = "none";
                }

                if (buttonShowMore) {
                    if (!response.hasNextPage) {
                        buttonShowMore.style.display = 'none';
                    } else {
                        buttonShowMore.dataset.page = 2;
                        buttonShowMore.style.display = 'flex';
                    }
                }
            }
            request.open('GET', `/ajax/get-stories-filter/?idPage=${idPage}&industries=${industries}&painpoints=${painpoints}`);
            request.send();
        });
    });

    $clearButton.addEventListener("click", () => {
        isClear = true;
        fields.forEach(($field, index) => {
            $field.dispatchEvent(new CustomEvent("handle-clear-value"));
        });
        isClear = false;

        const request = new XMLHttpRequest();
        request.onload = () => {
            const response = JSON.parse(request.responseText);
            const template = document.querySelector('.ns-customer-stories__article-card-template');
            template.parentNode.querySelector('.ns-customer-stories__col').textContent = '';

            for (const story of response.stories) {
                const clone = template.content.cloneNode(true);
                clone.querySelector('.ns-article-card').href = story.alias;
                clone.querySelector('.ns-article-card').dataset.order = story.order;
                clone.querySelector('.ns-article-card__type-text').textContent = story.industry;
                clone.querySelector('.ns-article-card__title').textContent = story.title;
                clone.querySelector('.ns-article-card__description').textContent = story.description;

                if (story.media.type === 'image') {
                    clone.querySelector('img').src = story.media.src;
                    clone.querySelector('video').style.display = 'none';
                    clone.querySelector('.ns-article-card__type-video-marker').style.display = 'none';
                } else if (story.media.type === 'video') {
                    clone.querySelector('source').src = story.media.src;
                    clone.querySelector('source').type = story.media.mime;
                    clone.querySelector('img').style.display = 'none';
                }

                template.parentNode.querySelector('.ns-customer-stories__col').appendChild(clone);
            }

            if(response.stories.length < 1){
                document.querySelector(".ns-article-card__no-result--search").style.display = "block";
            }
            else{
                document.querySelector(".ns-article-card__no-result--search").style.display = "none";
            }

            if (buttonShowMore) {
                if (!response.hasNextPage) {
                    buttonShowMore.style.display = 'none';
                } else {
                    buttonShowMore.dataset.page = 2;
                    buttonShowMore.style.display = 'flex';
                }
            }
        }
        request.open('GET', `/ajax/get-stories-filter/?idPage=${idPage}&industries=&painpoints=`);
        request.send();

        const fieldsMobile = containerMobile.querySelectorAll(".ns-multiselect");
        fieldsMobile.forEach(($field) => {
            $field.dispatchEvent(new CustomEvent("handle-clear-value"));
        });
    });
};

const initMobileFilter = () => {
    const $openButton = document.querySelector(
        ".ns-customer-stories__mobile-open"
    );
    const $clearButton = document.querySelector(
        ".ns-customer-stories__mobile-controls .ns-customer-stories__clear"
    );

    const fields = containerMobile.querySelectorAll(".ns-multiselect");
    const $containerClearFilter = containerMobile.querySelector(
        ".ns-customer-stories-mobile-filter__clear"
    );
    const $closeButton = containerMobile.querySelector(
        ".ns-customer-stories-mobile-filter__close"
    );
    const $form = containerMobile.querySelector(
        ".ns-customer-stories-mobile-filter__form"
    );

    const handleOpen = () => {
        containerMobile.classList.add("ns-customer-stories-mobile-filter--active");
    };

    const handleClose = () => {
        containerMobile.classList.remove(
            "ns-customer-stories-mobile-filter--active"
        );
    };

    const handleDropFilters = () => {
        fields.forEach(($field) => {
            $field.dispatchEvent(new CustomEvent("handle-clear-value"));
        });
    };

    const handleClear = () => {
        handleDropFilters()

        onSubmitForm()
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        onSubmitForm()

        handleClose();
    };

    $openButton.addEventListener("click", handleOpen);

    $closeButton.addEventListener("click", handleClose);

    $containerClearFilter.addEventListener("click", () => {
        handleClear();
        fields.forEach(($field, index) => {
            $field.dispatchEvent(new CustomEvent("handle-clear-value"));
        });
    });

    $clearButton.addEventListener('click', () => {
        handleClear();
        fields.forEach(($field, index) => {
            $field.dispatchEvent(new CustomEvent("handle-clear-value"));
        });
    });

    $form.addEventListener("submit", (e) => handleSubmit(e));
};

const init = () => {
    if (!section) {
        return;
    }

    idPage = section.dataset.idPage;

    if (!container) {
        return;
    }

    initDesktopFilter();
    initMobileFilter();
};

window.addEventListener("DOMContentLoaded", init, false);

if (buttonShowMore) {
    buttonShowMore.addEventListener('click', () => {
        const request = new XMLHttpRequest();
        request.onload = () => {
            const response = JSON.parse(request.responseText);
            const template = document.querySelector('.ns-customer-stories__article-card-template');

            for (const story of response.stories) {
                const clone = template.content.cloneNode(true);
                clone.querySelector('.ns-article-card').href = story.alias;
                clone.querySelector('.ns-article-card').dataset.order = story.order;
                clone.querySelector('.ns-article-card__type-text').textContent = story.industry;
                clone.querySelector('.ns-article-card__title').textContent = story.title;
                clone.querySelector('.ns-article-card__description').textContent = story.description;

                if (story.media.type === 'image') {
                    clone.querySelector('img').src = story.media.src;
                    clone.querySelector('video').style.display = 'none';
                    clone.querySelector('.ns-article-card__type-video-marker').style.display = 'none';
                } else if (story.media.type === 'video') {
                    clone.querySelector('source').src = story.media.src;
                    clone.querySelector('source').type = story.media.mime;
                    clone.querySelector('img').style.display = 'none';
                }

                template.parentNode.querySelector('.ns-customer-stories__col').appendChild(clone);
            }

            if (!response.hasNextPage) {
                buttonShowMore.style.display = 'none';
            } else {
                buttonShowMore.dataset.page++
            }
        }
        const prevPagesWithOrder = document.querySelectorAll(".ns-article-card:not([data-order=''])");
        const countPrevPagesWithOrder = prevPagesWithOrder.length;
        let lastOrderIndex = null;
        if (countPrevPagesWithOrder > 0){
            lastOrderIndex = prevPagesWithOrder[prevPagesWithOrder.length - 1].dataset.order;
        }
        else{
            lastOrderIndex = "0";
        }
        const countPrevPagesWithoutOrder = document.querySelectorAll(".ns-article-card[data-order='']").length;
        request.open('GET', `/ajax/get-stories-more/?page=${buttonShowMore.dataset.page}&idPage=${idPage}&industries=${industries}&painpoints=${painpoints}&countPrevPagesWithOrder=${countPrevPagesWithOrder}&countPrevPagesWithoutOrder=${countPrevPagesWithoutOrder}&lastOrderIndex=${lastOrderIndex}`);
        request.send();
    });
}

